<div
  class="direct-block jumbotron jumbotron-fluid mb-0"
  [ngStyle]="{
    'background-image': 'url(' + content.url + ')',
    'background-color': content.bgcolor,
  }"
>
  <div class="container">
    <h2 class="display-4" [ngStyle]="{ color: content.color }">
      {{ content.title }}
    </h2>
    <div class="row">
      <div *ngFor="let record of sellerNews" class="col-sm-12 col-md-6 px-0">
        <div
          class="m-auto col-11 p-0 bg-white rounded"
          [ngStyle]="{ color: content.color }"
        >
          <h3 class="font-weight-bold">{{ record.title }}</h3>
          <div class="row">
            <div class="col-8">
              <div class="font-size" [innerHtml]="record.body"></div>
              <div class="row text-secondary">
                <div *ngIf="record.author" class="col text-left">
                  by {{ record.author }}
                </div>
                <div class="col text-right">
                  {{ record.created_date | date }}
                </div>
              </div>
            </div>
            <div class="col-4 pl-0">
              <img
                loading="lazy"
                [src]="record.title_image"
                style="max-width: 100%; max-height: 100%"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
